import {
  shippersHaveLoadedSelector,
  shippersSortedByIDSelector,
} from '../../../data/shippers.js'
import {warehousesHaveLoadedSelector} from '../../../data/warehouses.js'
import {settingsPermissionsSelector} from '../settingsFunctions.js'
import SettingsPanel from '../SettingsPanel.js'
import EditForm from './EditForm.js'
import NewForm from './NewForm.js'
import {isNewPlansSelector} from '../../../data/company.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import {showShipperSortModal} from './ShipperSortModal.js'
import {onlyIfAutoForm, useSelector} from '../../../store.js'
import {setupShippersForm} from './ShippersFunctions.js'
import Icon from '../../../common/icons/Icon.js'

function Shippers() {
  const shippers = useSelector(shippersSortedByIDSelector)
  const isNewPlans = useSelector(isNewPlansSelector)
  const hasPermission = useSelector(settingsPermissionsSelector).shipper
  const hasLoaded = useSelector(
    (state) =>
      warehousesHaveLoadedSelector(state) && shippersHaveLoadedSelector(state),
  )

  return (
    <SettingsPanel
      header="Shipper Settings"
      subHeader={
        <>
          {isNewPlans && (
            <div className="margin-bottom-20">
              Automatically access unlimited shipping labels on UPS, USPS, and
              Sendle. To ship with unlimited carrier accounts across other
              carriers, additional fees may apply.
            </div>
          )}
          <div>
            <ButtonPrimary
              size="sm"
              className="flex align-items-center"
              isOutlined
              onClick={() => showShipperSortModal()}
            >
              <Icon name="reorder" className="fs-02 lh-0 margin-right-5" />
              <span>Set Order</span>
            </ButtonPrimary>
          </div>
        </>
      }
      hasPermission={hasPermission}
    >
      {hasLoaded && (
        <div className="row">
          <div className="medium-12 columns">
            <ul className="settings-list">
              {shippers.map((shipper) => (
                <EditForm key={shipper.id} shipper={shipper} />
              ))}
              <NewForm />
            </ul>
          </div>
        </div>
      )}
    </SettingsPanel>
  )
}

export default onlyIfAutoForm(Shippers, setupShippersForm)
